// @ts-nocheck
import React, { useEffect } from 'react';

import { LightMenuWithTopBannerAndAuthDialog as LightMenu } from '@crehana/web';

import { InitialStateResult } from 'Jsx/Utils/getBaseInitialState';

import Hero from './sections/Hero';
import Steps from './sections/Steps';

import { Landing } from './types';

export type ExtraState = {};

export type AppProps = {
  landing: Landing;
};

const App: React.FC<InitialStateResult<AppProps & ExtraState>> = ({
  categories,
  countryPrefix,
  landing,
}) => {
  return (
    <React.Fragment>
      <LightMenu position="absolute" isTransparent />
      <Hero
        landingId={landing.originalId}
        title={landing.title}
        description={landing.description}
        promoImageUrl={landing.promoImageUrl}
        buttonLabel={landing.landingProperty.buttonText}
        nextUrl={landing.landingProperty.nextUrl}
        couponCode={landing.landingProperty.coupon.code}
        itemId={landing.landingProperty.itemId}
        itemType={landing.itemType}
      />
      <Steps couponCode={landing.landingProperty.coupon.code} />
    </React.Fragment>
  );
};

export default App;
